import { render, staticRenderFns } from "./consecutivo.vue?vue&type=template&id=9d85c6ee&"
import script from "./consecutivo.vue?vue&type=script&lang=js&"
export * from "./consecutivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports